import { sendToNewRelic } from '@skyscanner-internal/landing-pages-shared-ui/src/utils';
import observer from 'saddlebag-observer';

export const sendYoloScriptDisplayedCustomAttribute = (
  value: string,
  windowObject: Record<string, any>,
) => sendToNewRelic('yoloScriptDisplayed', value, windowObject);

export default (windowObject: Record<string, any>) => {
  sendToNewRelic('viewportWidth', windowObject.innerWidth, windowObject);
  sendToNewRelic('viewportHeight', windowObject.innerHeight, windowObject);

  /* eslint-disable no-underscore-dangle */
  const vertical =
    windowObject.__internal.trackingVertical ||
    windowObject.__internal.vertical;
  /* eslint-enable no-underscore-dangle */
  sendToNewRelic('vertical', vertical, windowObject);
  observer.subscribe('sid-yolo-display-success', () =>
    sendYoloScriptDisplayedCustomAttribute('success', windowObject),
  );
  observer.subscribe('sid-yolo-display-failed', () =>
    sendYoloScriptDisplayedCustomAttribute('fail', windowObject),
  );
};
